import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { formatAthens } from "./social/SocialOverview";

// Public status page for Meta data-deletion requests (ig-publish).
// Meta shows the user a link to /deletion/status?code=<confirmation_code>.
const LABELS = {
  completed: "Completed. The Instagram data linked to this request has been deleted.",
  pending: "Received. The data will be deleted within 30 days.",
};

export default function DeletionStatus() {
  const code = new URLSearchParams(window.location.search).get("code") || "";
  const [state, setState] = useState({ loading: Boolean(code), data: null, error: code ? "" : "missing" });

  useEffect(() => {
    if (!code) return undefined;
    let alive = true;
    api.get("/api/meta/data-deletion/status", { params: { code } })
      .then((r) => alive && setState({ loading: false, data: r.data, error: "" }))
      .catch((e) => alive && setState({ loading: false, data: null, error: e?.response?.status === 404 ? "unknown" : "failed" }));
    return () => { alive = false; };
  }, [code]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-black p-6 text-white">
      <div className="w-full max-w-md rounded-xl border bg-black/70 p-8"
        style={{ borderColor: "rgba(255, 16, 240, 0.35)", boxShadow: "0 0 30px -16px #FF10F0" }} data-testid="deletion-status">
        <h1 className="text-2xl font-bold">Data deletion status</h1>
        {state.loading && <p className="mt-4 text-zinc-400">Checking…</p>}
        {state.error === "missing" && <p className="mt-4 text-zinc-300">No confirmation code was given. Use the link from your deletion confirmation.</p>}
        {state.error === "unknown" && <p className="mt-4 text-amber-300" data-testid="deletion-unknown">We could not find a request with this confirmation code.</p>}
        {state.error === "failed" && <p className="mt-4 text-red-300">The status could not be loaded. Please try again later.</p>}
        {state.data && (
          <div className="mt-4 space-y-2 text-sm">
            <p className="text-zinc-300" data-testid="deletion-state">{LABELS[state.data.status] || `Status: ${state.data.status}`}</p>
            <p className="text-zinc-500">Confirmation code: <span className="font-mono text-zinc-300">{state.data.confirmation_code}</span></p>
            {state.data.requested_at && <p className="text-zinc-500">Requested: {formatAthens(state.data.requested_at)}</p>}
            {state.data.completed_at && <p className="text-zinc-500">Completed: {formatAthens(state.data.completed_at)}</p>}
          </div>
        )}
        <p className="mt-6 text-xs text-zinc-500">Questions? Email <a href="mailto:privacy@giopilos.com" className="text-pink-300">privacy@giopilos.com</a>.</p>
      </div>
    </div>
  );
}
